import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/follow-ups` is a redirect, not a screen.
 *
 * Legacy's `WBS_Group_Extension::load_default_subnav_screen` (`:329-335`) 302s
 * the bare tab slug to the FIRST registered subnav, and both follow-up
 * extensions register Pending Requests first
 * (`class-follow-up-coordinator-group-follow-up.php:22-25`,
 * `class-follow-up-partner-group-follow-up.php`). Measured live on both tabs.
 *
 * The nav item this group adds points at the bare `/follow-ups`, so without
 * this the header link renders the tab strip over an empty outlet. Same shape
 * and same reasoning as `$groupName.follow-ups.index.tsx`, which answers the
 * identical question for the study-group tab; `beforeLoad` rather than a
 * component effect because the answer needs no payload.
 *
 * Only the BARE slug. Legacy's `templateNotFound()` (`:341-346`) also redirects
 * any unrecognised slug under the tab, and that is deliberately not built — a
 * catch-all splat is a second routing mechanism for a URL nobody navigates to.
 */
export const Route = createFileRoute('/_app/follow-ups/')({
  beforeLoad: () => {
    throw redirect({ to: '/follow-ups/pending-requests/', replace: true });
  },
});
